import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import UsersListItem from './UsersListItem';
import UsersDetails from './details/UsersDetails';

import buttons from './UsersButtons';
import events from './UsersEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	routes: [
		{
			path: 'users/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'users'),
			element: (
				<DetailsPage
					key="users/add"
					module="users"
					headerOptions={{ showAvatar: true }}
					tabs={UsersDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},
		{
			path: 'users/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'users'),
			element: (
				<DetailsPage
					key="users/details"
					module="users"
					headerOptions={{ showAvatar: true }}
					tabs={UsersDetails}
					buttons={buttons.details}
					events={events}
				/>
			)
		},
		{
			path: 'users/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'users'),
			element: (
				<ViewPage
					key="users/view"
					module="users"
					content={{ type: 'list', itemLayout: UsersListItem, id: 'usersView' }}
					buttons={buttons.view}
					filters={[{ filt_field: 'user_enabled', filt_clause: 'equals', filt_value: 1 }]}
				/>
			)
		}
	]
};

export default routes;
